import api from '@/lib/api'

export interface UserPreferences {
  skip_onboarding_redirect?: boolean
}

export interface UserProfileUpdate {
  name?: string
}

export interface UserResponse {
  id: string
  email: string
  name: string
  role: string
  tenant_id: string | null
  tenant_name: string | null
  is_super_admin: boolean
  skip_onboarding_redirect: boolean
}

export interface NotificationPreferences {
  email: boolean
  slack: boolean
  in_app: boolean
  slack_webhook_url: string | null
}

export interface NotificationPreferencesUpdate {
  email?: boolean
  slack?: boolean
  in_app?: boolean
  slack_webhook_url?: string
}

export interface TenantResponse {
  id: string
  name: string
  slug: string
  plan: string
}

export interface TenantUpdate {
  name?: string
}

export interface TenantBrandingResponse {
  brand_website_url: string | null
  primary_color: string | null
  secondary_color: string | null
  logo_url: string | null
  company_name: string | null
  extraction_status: 'none' | 'pending' | 'extracting' | 'completed' | 'failed' | null
  extraction_error: string | null
  last_extraction_at: string | null
}

export interface BrandingExtractRequest {
  website_url: string
}

export interface BrandingExtractResponse {
  status: string
  message: string
}

export const usersService = {
  async updatePreferences(preferences: UserPreferences): Promise<UserResponse> {
    const { data } = await api.patch<UserResponse>('/users/me/preferences', preferences)
    return data
  },

  async updateProfile(profile: UserProfileUpdate): Promise<UserResponse> {
    const { data } = await api.patch<UserResponse>('/users/me', profile)
    return data
  },

  async getNotificationPreferences(): Promise<NotificationPreferences> {
    const { data } = await api.get<NotificationPreferences>('/users/me/notification-preferences')
    return data
  },

  async updateNotificationPreferences(preferences: NotificationPreferencesUpdate): Promise<NotificationPreferences> {
    const { data } = await api.patch<NotificationPreferences>('/users/me/notification-preferences', preferences)
    return data
  },
}

export const tenantsService = {
  async getCurrentTenant(): Promise<TenantResponse> {
    const { data } = await api.get<TenantResponse>('/tenants/me')
    return data
  },

  async updateTenant(update: TenantUpdate): Promise<TenantResponse> {
    const { data } = await api.patch<TenantResponse>('/tenants/me', update)
    return data
  },

  async getBranding(): Promise<TenantBrandingResponse> {
    const { data } = await api.get<TenantBrandingResponse>('/tenants/me/branding')
    return data
  },

  async extractBranding(request: BrandingExtractRequest): Promise<BrandingExtractResponse> {
    const { data } = await api.post<BrandingExtractResponse>('/tenants/me/branding/extract', request)
    return data
  },
}
